import React from 'react';

import { Skeleton } from 'components/ui/skeleton';

export function Banner({ bannerUrl }: { bannerUrl: string }) {
  return (
    <div
      data-testid="banner"
      className="h-[240px] w-full bg-contain bg-center bg-no-repeat sm:h-[320px] md:h-[480px] xl:h-[600px]"
      style={{ backgroundImage: `url(${bannerUrl})` }}
    />
  );
}

Banner.Skeleton = function BannerSkeleton() {
  return (
    <Skeleton className="h-[240px] w-full sm:h-[320px] md:h-[480px] xl:h-[600px]" />
  );
};
